import * as R from 'ramda';
export const FileTypes = {
    DeathCertificate: "DeathCertificate",
    Signature: "Signature",
    Letter: "Letter",
    TransportationInvoice: "Death.UnderTaker.TransportationInvoice",
    FuneralServicesInvoice: "Death.UnderTaker.Invoice",
    UserRepresentativeHeirProof: "UserRepresentative.Heir.Proof",
    UserRepresentativeRib: "UserRepresentative.Rib",
    UserRepresentativeIdCard: "UserRepresentative.IdCard",
    UserRepresentativeHealthCertificate: "UserRepresentative.HealthCertificate",
    UserRepresentativeFiscalSituation: "UserRepresentative.FiscalSituation",
    UserRepresentativeInvalidPensionCertificate: "UserRepresentative.InvalidPensionCertificate",
    UserRepresentativeWorkDiseasePensionCertificate: "UserRepresentative.WorkDiseasePensionCertificate",
    UserRepresentativeWorkIncidentPensionCertificate: "UserRepresentative.WorkIncidentPensionCertificate",
    UserRepresentativeRetiredPensionCertificate: "UserRepresentative.RetiredPensionCertificate",
    UserPensionProof: "User.PensionProof",
    UserSocialSecurityCard: "User.SocialSecurityCard",
    UserSocialSecurityRightCertificate: "User.SocialSecurityRightCertificate",
    UserRetiredPensionCertificate: "User.RetiredPensionCertificate",
    UserInvalidPensionCertificate: "User.InvalidPensionCertificate",
    UserChildrenIdCard: "User.Children.IdCard",
    UserIdCard: "User.IdCard",
    UserFamilyRecordBook: "User.FamilyRecordBook",
    UserDonation: "User.Donation",
    Other: "Other",
    ProfilePicture: "ProfilePicture",
    Folder: "Folder",
    FolderRH: "FolderRH",
    Payslip: "Payslip"
};

export function FiletypeToDisplayName(fileType, isFacilita){
    if(R.isNil(isFacilita)){
        isFacilita = true;
    }
    const displayNameMapping = {
        [FileTypes.DeathCertificate] : "Acte de décès",
        [FileTypes.Signature] : "Signature",
        [FileTypes.Letter] : "Lettre",
        [FileTypes.TransportationInvoice] : "Facture des frais de transport du corps",
        [FileTypes.FuneralServicesInvoice] : "Facture des pompes funèbres",
        [FileTypes.UserRepresentativeHeirProof] : "Certificat de notoriété attestant de ma qualité d’héritier",
        [FileTypes.UserRepresentativeRib] : "RIB du mandataire",
        [FileTypes.UserRepresentativeIdCard] : "Pièce justificative de l'identité du mandataire",
        [FileTypes.UserRepresentativeHealthCertificate] : "Certificat médical constatant de l'incapacité du mandataire",
        [FileTypes.UserRepresentativeFiscalSituation] : "Situation fiscale du mandataire",
        [FileTypes.UserRepresentativeInvalidPensionCertificate] : "Notification du mandataire pour l'attribution pension d'invalidité",
        [FileTypes.UserRepresentativeWorkDiseasePensionCertificate] : "Notification du mandataire pour l'attribution de rente pour maladie professionnelle ",
        [FileTypes.UserRepresentativeWorkIncidentPensionCertificate] : "Notification du mandataire pour l'attribution de rente pour accident du travail",
        [FileTypes.UserRepresentativeRetiredPensionCertificate] : "Notification du mandataire d'attribution de pension de retraite",
        [FileTypes.UserPensionProof] : "Attestation de rente du défunt (MP ou AT)",
        [FileTypes.UserSocialSecurityCard] : "Carte vitale du défunt",
        [FileTypes.UserSocialSecurityRightCertificate] : "Attestation de droits du défunt",
        [FileTypes.UserRetiredPensionCertificate] : "Notification d'attribution de pension d'invalidité du défunt",
        [FileTypes.UserInvalidPensionCertificate] : "Notification d'attribution de pension de retraite du défunt",
        [FileTypes.UserChildrenIdCard] : "Pièces justificatives de l'identité des enfants à charge du défunt",
        [FileTypes.UserIdCard] : isFacilita ? "Pièces justificatives de l'identité du défunt" : "Pièces justificatives de votre identité",
        [FileTypes.UserFamilyRecordBook] : "Livret de famille" + (isFacilita ? " du défunt" : ""),
        [FileTypes.UserDonation] : "Donation" + (isFacilita ? " du défunt" : ""),
        [FileTypes.Other] : "Autres",
        [FileTypes.ProfilePicture] : "Image de profil",
        [FileTypes.Payslip] : "Bulletin de paie"
    }
    return displayNameMapping[fileType];
}